import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 */
export interface SurveyTemplateSearchedArgs {
  resultReturned: boolean;
  textTyped?: string;
}

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 * A survey template was searched
 */
export const surveyTemplateSearched = (args: SurveyTemplateSearchedArgs): void => {
  Segment.track('Searched Survey Template', keysToSnakeCase(args));
};
